import React from "react"
import { Snippet } from "react-instantsearch"
// import "./NavSearch.scss"
import { InitializeAlgoliaAnalytics, getUserToken } from "./AlgoliaAnalytics"
import aa from "search-insights"

// Initialized Algolia Analytics
InitializeAlgoliaAnalytics()

// Get User Token
const userToken = getUserToken()

const indexName = process.env.ALGOLIA_SITE_INDEX || "global-production";

// Handle Click Event for Search Results (Algolia Analytics)
function handleSearchResultClick(objectID: any, queryID: any, position: any) {
  aa("clickedObjectIDsAfterSearch", {
    userToken: userToken,
    eventName: "Click on Search Result",
    index: indexName,
    queryID: queryID,
    objectIDs: [objectID],
    positions: [position],
  })
}

interface SearchHitProps {
  hit: any, 
  locale: string
}

const SearchHit = ({ hit, locale }: SearchHitProps) => {
  const { site, contentTypeName, title, url, path } = hit || {}

  const hasLocale = hit.locale

  const renderLinkMarkup = (url: string) => {
    const currentLocation = window.location.origin
    if (url.startsWith(currentLocation)) {
      // if search result URL origin matches current site origin, it's an internal link: use Gatsby Link object
      const newUrl = url.replace(currentLocation, "")
      return (
        <a
          href={newUrl}
          className="nav-search__hit--link"
          style={{ margin: 0 }}
          onClick={() =>
            handleSearchResultClick(
              hit?.objectID,
              hit?.__queryID,
              hit?.__position
            )
          }
        >
          {title || site || path}
        </a>
      )
    }
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer noopener"
        className="nav-search__hit--link"
        style={{ margin: 0 }}
        onClick={() =>
          handleSearchResultClick(
            hit?.objectID,
            hit?.__queryID,
            hit?.__position
          )
        }
      >
        {title || site || path}
      </a>
    )
  }

  // hit
  //   ? (hit?.locale?.split("-")?.[0].toLowerCase() ===
  //       locale.split("-")?.[0].toLowerCase() ||
  //       (!hasLocale && locale.split("-")?.[0].toLowerCase())) &&

  return (
    <div>
      <span className="nav-search__hit--breadcrumb">{hit?.hostname}</span>
      <br />
      {url && renderLinkMarkup(url)}
      <div className="nav-search__hit--description">
        {hit?.description || <Snippet attribute="content" hit={hit} />}
      </div>
      {hit.contentType && (
        <div className="nav-search__hit--content-type">
          <strong>Category:</strong> {hit?.contentType}
        </div>
      )}
      <hr className="nav-search__hit--divider"></hr>
    </div>
  )
}

export default SearchHit
